import { FormsActionTypes, FormsEntities } from '@bimser/common';
import { createSyncAction } from '@bimser/core';
import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { List, Map } from 'immutable';
import { put } from 'redux-saga/effects';
import Hash from 'object-hash';
import { RuleEngineLegacyEntities } from '@bimser/components/dist/BCRuleManager';
import { convertActionValue } from '../../../action';

export function* runValueAssaignWithEntryAction(
	action: RuleEngineLegacyEntities.IValueAssignActionWithEntry,
	getOldFormData: () => Map<string, LayoutCreatorEntities.LayoutDataItem>,
	windowId: string
) {
	// Update data for next action
	const oldFormData = yield getOldFormData();

	let changeData: List<FormsEntities.PropertyChangeEventArgs> = List();

	const targetPath = action.field.propertyName.split('.');
	const targetId = action.field.name;

	const { dataField, value } = convertActionValue(
		action.field,
		action.value,
		oldFormData,
		targetPath
	);

	let oldValue = oldFormData.getIn([targetId, 'properties', ...dataField]);
	let newValue = value;

	// Check value equality
	if (typeof oldValue === 'object') {
		oldValue = Hash(oldValue);
	}
	if (typeof newValue === 'object') {
		newValue = Hash(newValue);
	}

	if (oldValue === newValue) {
		return;
	}
	// Check value equality: end

	const pLoad = FormsEntities.PropertyChangeEventArgsFactoryFromJS({
		dataField,
		handled: false,
		id: targetId,
		value
	});

	changeData = changeData.set(changeData.count(), pLoad);

	const changeTransaction = FormsEntities.PropertyChangeTransactionFactory({
		data: changeData
	});

	const changePropertyAction = createSyncAction(
		FormsActionTypes.CHANGE_PROPERTY,
		FormsEntities.PropertyChangeActionFactory({ data: changeTransaction, windowId })
	);
	yield put(changePropertyAction);
}
